import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fd0e608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tit-top" }
const _hoisted_2 = { class: "chart-block" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart1-tit" }, "总资产结构图", -1))
const _hoisted_5 = { class: "chart-table table1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "指标 2021-06-30"),
  /*#__PURE__*/_createElementVNode("span", null, "金额"),
  /*#__PURE__*/_createElementVNode("span", null, "占比")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总资产", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "100%", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "流动资产", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "非流动资产", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "chart2-tit" }, "总负债结构图", -1))
const _hoisted_12 = { class: "chart-table table2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("span", null, "指标 2021-06-30"),
  /*#__PURE__*/_createElementVNode("span", null, "金额"),
  /*#__PURE__*/_createElementVNode("span", null, "占比")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总负债金额", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "100%", -1))
const _hoisted_16 = { class: "cont-nav" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "table-block"
}
const _hoisted_19 = {
  border: "1",
  bordercolor: "#ccc"
}
const _hoisted_20 = { border: "1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数值", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "占比", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_popover, {
            content: "百分比报表用于结构分析，因此仅展示重要科目，完整报表请参考公司相应财报。",
            trigger: "hover",
            arrowPointAtCenter: "",
            placement: "topLeft"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InfoCircleOutlined, { style: {"margin-left":"6px"} })
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Charts, {
              id: "NumberofShareholders1",
              option: _ctx.option1
            }, null, 8, ["option"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _hoisted_6,
              _createElementVNode("li", null, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.getNumber2(_ctx.data1.total)), 1),
                _hoisted_8
              ]),
              _createElementVNode("li", null, [
                _hoisted_9,
                _createElementVNode("span", null, _toDisplayString(_ctx.getNumber2(_ctx.data1.ldzcTotal)), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.computedPrecent(_ctx.data1.ldzcTotal, _ctx.data1.total)), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data1.ldzc, (item, idx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'ldzc' + idx
                }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      style: _normalizeStyle({ background: item.color })
                    }, null, 4),
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getNumber2(item.value)), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.computedPrecent(item.value, _ctx.data1.total)), 1)
                ]))
              }), 128)),
              _createElementVNode("li", null, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.getNumber2(_ctx.data1.fldzcTotal)), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.computedPrecent(_ctx.data1.fldzcTotal, _ctx.data1.total)), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.data1.fldzc||[]).slice(0,4), (item, idx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'fldzc' + idx
                }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      style: _normalizeStyle({ background: item.color })
                    }, null, 4),
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getNumber2(item.value)), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.computedPrecent(item.value, _ctx.data1.total)), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_11,
            _createVNode(_component_Charts, {
              id: "NumberofShareholders2",
              option: _ctx.option2
            }, null, 8, ["option"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", null, [
              _hoisted_13,
              _createElementVNode("li", null, [
                _hoisted_14,
                _createElementVNode("span", null, _toDisplayString(_ctx.getNumber2(_ctx.data2.total)), 1),
                _hoisted_15
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data2.data, (item, idx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'data2' + idx
                }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("i", {
                      style: _normalizeStyle({ background: item.color })
                    }, null, 4),
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getNumber2(item.value)), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.computedPrecent(item.value, _ctx.data2.total)), 1)
                ]))
              }), 128))
            ])
          ])
        ], 512), [
          [_vShow, _ctx.pageSourceData.EnterpriseType === 99 && (_ctx.data || []).length]
        ]),
        _createElementVNode("nav", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: 'tag' + i,
              class: _normalizeClass({ active: tag.value === _ctx.activeTagVal }),
              onClick: ($event: any) => (_ctx.checkTag(tag))
            }, _toDisplayString(tag.label), 11, _hoisted_17))
          }), 128))
        ]),
        ((_ctx.data || []).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", null, [
                _createElementVNode("table", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'data2' + idx
                    }, [
                      _createElementVNode("th", null, [
                        _createElementVNode("div", {
                          class: _normalizeClass([{ 'bold-th': !item.indentStep },'indent'+item.indentStep])
                        }, _toDisplayString(item.title), 3)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("table", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, idx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (item.key === 'Title')
                        ? (_openBlock(), _createElementBlock("tr", {
                            key: 'data3' + idx
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (td, i) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: 'data2' + i
                              }, _hoisted_23))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("tr", { key: idx }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (td, idx) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: 'data4' + idx
                              }, [
                                (item.slots && item.slots.customRender === 'twoNumber')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      _createElementVNode("span", null, _toDisplayString(_ctx.formatNum(td[item.key])), 1),
                                      _createElementVNode("span", null, _toDisplayString(td[item.key] && String(td[item.key]) !== "0" && td['FM'] && String(td[item.key]) !== "0"
                          ? ((td[item.key] / td['FM'] || 0)*100).toFixed(2) + "%"
                          : "—"), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(td[item.key] || "—"), 1))
                              ]))
                            }), 128))
                          ]))
                    ], 64))
                  }), 256))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_26, [
              _createVNode(_component_Nodata, {
                nodatadesc: _ctx.itemdata.title
              }, null, 8, ["nodatadesc"])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}